const DEFAULT_SERVICE_ERROR = '服務異常，請聯繫相關人員'

/**
 * 建立 response interceptor 要 reject 的內容。
 *
 * 全站預設維持字串，避免破壞既有頁面直接顯示 catch 內容的行為；
 * 只有明確設定 rejectWithDetail 的端點才回傳可依 errorCode 分流的物件。
 */
export function buildServiceRejection(response) {
	const message = response?.data?.message || DEFAULT_SERVICE_ERROR
	if (!response?.config?.rejectWithDetail) {
		return message
	}
	return {
		message,
		errorCode: response?.data?.errorCode,
		status: response?.status,
	}
}
